// extracted by mini-css-extract-plugin
export default {"pageWrap":"_b-z","fullWidth":"ac-z","heading":"bc-z","fullBleed":"cc-z","hidden":"dc-z"};